import { render, staticRenderFns } from "./DetailedFilter.vue?vue&type=template&id=8d0b80f6&"
import script from "./DetailedFilter.vue?vue&type=script&lang=js&"
export * from "./DetailedFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports